import {Directive, HostListener, Input} from '@angular/core';
import {Location, PlatformLocation} from "@angular/common";

@Directive({
  selector: '[appSocialShare]',
})
export class SocialShareDirective {
  @Input() appSocialShare: 'fb'|'line'|null = null;

  constructor(private platformLocation:PlatformLocation) {
    // console.log('location', this.platformLocation.getBaseHrefFromDOM());
  }

  @HostListener('click', ['$event']) onClick($event:Event) {
    // console.log('click', this.appSocialShare, $event);
    let url = location.origin + this.platformLocation.getBaseHrefFromDOM() +
        'home?ID=' + localStorage.getItem('CODE')
        + '&src=' + this.appSocialShare + '&openExternalBrowser=1';
    url = encodeURIComponent(url);
    // console.log('url', url);
    switch(this.appSocialShare) {
      case 'fb':
        window.open('https://www.facebook.com/sharer/sharer.php?u='+url);
        break;
      case 'line':
        window.open('https://lineit.line.me/share/ui?url='+url);
        break;
      default:
        console.warn('unknown social', this.appSocialShare);
    }
    $event.preventDefault();
  }
}
